/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './birth-history.reducer';

export const BirthHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const birthHistoryList = useAppSelector(state => state.birthHistory.entities);
  const loading = useAppSelector(state => state.birthHistory.loading);
  const totalItems = useAppSelector(state => state.birthHistory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="birth-history-heading" data-cy="BirthHistoryHeading">
        <Translate contentKey="tinyMedicRestApp.birthHistory.home.title">Birth Histories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.birthHistory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/birth-history/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.birthHistory.home.createLabel">Create new Birth History</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.birthHistory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {birthHistoryList && birthHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('gestation')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.gestation">Gestation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gestation')} />
                </th>
                <th className="hand" onClick={sort('delivery')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.delivery">Delivery</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('delivery')} />
                </th>
                <th className="hand" onClick={sort('birthWeight')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.birthWeight">Birth Weight</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('birthWeight')} />
                </th>
                <th className="hand" onClick={sort('birthHeight')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.birthHeight">Birth Height</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('birthHeight')} />
                </th>
                <th className="hand" onClick={sort('breastFed')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.breastFed">Breast Fed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('breastFed')} />
                </th>
                <th className="hand" onClick={sort('twins')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.twins">Twins</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('twins')} />
                </th>
                <th className="hand" onClick={sort('birthOrder')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.birthOrder">Birth Order</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('birthOrder')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.pregnancy">Pregnancy</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.recordedBy">Recorded By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.recordedAt">Recorded At</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.vitals">Vitals</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.mother">Mother</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.birthHistory.father">Father</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {birthHistoryList.map((birthHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/birth-history/${birthHistory.id}`} color="link" size="sm">
                      {birthHistory.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Gestation.${birthHistory.gestation}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.DeliveryType.${birthHistory.delivery}`} />
                  </td>
                  <td>{birthHistory.birthWeight}</td>
                  <td>{birthHistory.birthHeight}</td>
                  <td>{birthHistory.breastFed ? 'true' : 'false'}</td>
                  <td>{birthHistory.twins ? 'true' : 'false'}</td>
                  <td>{birthHistory.birthOrder}</td>
                  <td>{birthHistory.notes}</td>
                  <td>{birthHistory.active ? 'true' : 'false'}</td>
                  <td>{birthHistory.draft ? 'true' : 'false'}</td>
                  <td>{birthHistory.cursor}</td>
                  <td>{birthHistory.lastUpdated}</td>
                  <td>{birthHistory.microSec}</td>
                  <td>{birthHistory.timestampEntry}</td>
                  <td>
                    {birthHistory.pregnancy ? (
                      <Link to={`/pregnancy-case/${birthHistory.pregnancy.id}`}>{birthHistory.pregnancy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {birthHistory.recordedBy ? <Link to={`/doctor/${birthHistory.recordedBy.id}`}>{birthHistory.recordedBy.id}</Link> : ''}
                  </td>
                  <td>
                    {birthHistory.recordedAt ? (
                      <Link to={`/hospital/${birthHistory.recordedAt.id}`}>{birthHistory.recordedAt.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{birthHistory.vitals ? <Link to={`/vitals/${birthHistory.vitals.id}`}>{birthHistory.vitals.id}</Link> : ''}</td>
                  <td>
                    {birthHistory.patient ? <Link to={`/gluco-user/${birthHistory.patient.id}`}>{birthHistory.patient.id}</Link> : ''}
                  </td>
                  <td>{birthHistory.mother ? <Link to={`/gluco-user/${birthHistory.mother.id}`}>{birthHistory.mother.id}</Link> : ''}</td>
                  <td>{birthHistory.father ? <Link to={`/gluco-user/${birthHistory.father.id}`}>{birthHistory.father.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/birth-history/${birthHistory.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/birth-history/${birthHistory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/birth-history/${birthHistory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.birthHistory.home.notFound">No Birth Histories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={birthHistoryList && birthHistoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BirthHistory;
